import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { IMainMenuMobile } from '@modules/header/domain/models/menu.model';
import { itemListAnimation } from '../mainMenu/MainMenuMobile.animate';
import { ItemList, MenuImgWrapper, MenuText, WrapperItemList } from './MenuTitleMobile.style';
interface Props {
  menu: IMainMenuMobile;
  onClick: () => void;
}
const MenuTitleMobileWithLink: FC<Props> = ({
  menu,
  onClick
}: Props) => {
  const router = useRouter();
  const pagePath = router.pathname;
  return <ItemList variants={itemListAnimation} onClick={onClick}>
            <Link href={menu.redirectTo}>
                <WrapperItemList>
                    <MenuImgWrapper>
                        <Image src={menu.iconImgUrl} alt={menu.title} width={24} height={24} />
                    </MenuImgWrapper>
                    <MenuText className={`${pagePath === menu.redirectTo ? 'active' : ''}`}>
                        {menu.title}
                    </MenuText>
                </WrapperItemList>
            </Link>
        </ItemList>;
};
export default MenuTitleMobileWithLink;